import { jsx as _jsx } from "react/jsx-runtime";
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import BowtieSpinner from './BowtieSpinner';
const useStyles = makeStyles({
  container: {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    '& > $paper': {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  },
  paper: {}
});

const DialogSpinner = props => {
  const classes = useStyles();
  return _jsx(Dialog, {
    classes: {
      container: classes.container,
      paper: classes.paper
    },
    hideBackdrop: true,
    ...props,
    children: _jsx(BowtieSpinner, {})
  });
};

export default DialogSpinner;